
<template>
    <div class="circular-countdown">
        <div class="radial-progress-wrapper">
            <radial-progress-bar
                v-if="timeRemaining !== null"
                :diameter="40"
                :completed-steps="progress"
                :total-steps="durationInSeconds"
                :stroke-width="4"
                :inner-stroke-width="4"
                start-color="#57947f"
                stop-color="#57947f"
                inner-stroke-color="#ececec"
            />
        </div>
        <div class="countdown">
            {{ padTime(timeRemaining) }}
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import RadialProgressBar from './RadialProgressBar';

export default {
    props: ['startTime', 'durationInSeconds'],
    components: {
        RadialProgressBar,
    },
    name: 'CircularCountdown',
    data() {
        return {
            refreshInterval: null,
            timeRemaining: null,
            leftStyles: {
                transform: 'rotate(0deg)',
            },
            rightStyles: {
                transform: 'rotate(0deg)',
            },
            showCircleBackground: false,
        };
    },
    mounted() {
        this.startCountdown();
    },
    beforeUnmount() {
        clearInterval(this.refreshInterval);
    },
    computed: {
        progress() {
            if (this.timeRemaining === null) {
                return this.durationInSeconds;
            }
            const progress = this.durationInSeconds - this.timeRemaining;
            return progress <= this.durationInSeconds ? progress : this.durationInSeconds;
        },
    },
    methods: {
        getTimeRemaining() {
            const now = moment();
            const targetTime = moment(this.startTime).add(this.durationInSeconds, 'seconds');
            const timeLeftInSecs = Math.ceil(moment.duration(targetTime.diff(now)).valueOf() / 1000);
            return timeLeftInSecs >= 0 ? timeLeftInSecs : 0;
        },
        padTime(time) {
            return String(time).length === 1 && time !== 0 ? `0${time}` : time;
        },
        startCountdown() {
            const self = this;
            const intervalMs = 1000;

            clearInterval(this.refreshInterval);

            this.refreshInterval = setInterval(() => {
                this.timeRemaining = self.getTimeRemaining();

                this.updateCircularProgress(this.timeRemaining);

                if (this.timeRemaining === 0) {
                    clearInterval(this.refreshInterval);
                }
            }, intervalMs);
        },
        updateCircularProgress(timeRemaining) {
            if (!this.showCircleBackground) {
                this.showCircleBackground = true;
            }

            if (timeRemaining === 0) {
                this.leftStyles = {
                    transform: 'rotate(180deg)',
                };
                this.rightStyles = {
                    transform: 'rotate(180deg)',
                };

                return;
            }

            const durationInSeconds = this.durationInSeconds;
            const timeToCompleteHalfRotation = durationInSeconds / 2;
            const halfRotation = 180;
            const leftDegrees = halfRotation / (timeToCompleteHalfRotation / (durationInSeconds - timeRemaining));

            if (leftDegrees <= halfRotation && timeRemaining >= timeToCompleteHalfRotation) {
                this.leftStyles = {
                    transform: `rotate(${leftDegrees}deg)`,
                };
            }

            const rightDegrees = leftDegrees - halfRotation;

            if (rightDegrees <= halfRotation && timeRemaining <= timeToCompleteHalfRotation) {
                this.rightStyles = {
                    transform: `rotate(${rightDegrees}deg)`,
                };
            }
        },
    },
};
</script>

<style scoped lang="scss">
    @use "@/styles/styles.scss" as *;

    .countdown-wrapper {
        .countdown {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: .85rem;
        }
    }
</style>
